/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Blog_DescriptionInputs */

const en_landing_blog_description = /** @type {(inputs: Landing_Blog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product updates, guides, and engineering notes from the team.`)
};

const zh_landing_blog_description = /** @type {(inputs: Landing_Blog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`来自团队的产品动态、使用指南与工程笔记。`)
};

/**
* | output |
* | --- |
* | "Product updates, guides, and engineering notes from the team." |
*
* @param {Landing_Blog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_blog_description = /** @type {((inputs?: Landing_Blog_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Blog_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_blog_description(inputs)
	return zh_landing_blog_description(inputs)
});
export { landing_blog_description as "landing.blog.description" }